import { useRef } from 'react'
import { useComposerMentions } from './useComposerMentions'
import { useComposerImperativeHandle } from './useComposerImperativeHandle'
import { useComposerEditorLifecycle } from './useComposerEditorLifecycle'
import { useComposerEditorInstance } from './useComposerEditorInstance'

export function useComposerEditorModel(props, ref) {
  const {
    readOnly,
    textareaMaxHeightPx,
    onPlainTextChange,
    mentionMembers = [],
    mentionAgents = [],
    enableMentions = false,
  } = props

  const plainHandlerRef = useRef(onPlainTextChange)
  plainHandlerRef.current = onPlainTextChange

  const { editor, mentionRefs } = useComposerEditorInstance(props)

  const { mentionUsers, mentionAgentsList, syncMentionUi, insertMention } = useComposerMentions(
    editor,
    enableMentions,
    mentionMembers,
    mentionAgents,
    mentionRefs,
  )

  useComposerEditorLifecycle({ editor, readOnly, textareaMaxHeightPx, plainHandlerRef, syncMentionUi })
  useComposerImperativeHandle(ref, editor)

  return { editor, enableMentions, mentionRefs, mentionUsers, mentionAgentsList, insertMention }
}
